import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { IListByFilterPatient, IPatient } from '../../models/patient.interface';
import { PatientService } from '../../services/patient.service';

// triagens mais recentes primeiro: é o que o médico procura ao abrir a lista
const ORDENACAO_PADRAO = EOrdenacao.MaisNovos;

@Component({
  selector: 'app-pacientes',
  templateUrl: './pacientes.component.html',
  styleUrls: ['./pacientes.component.scss']
})
export class PacientesComponent implements OnInit {
  ordenarControl = new UntypedFormControl(ORDENACAO_PADRAO);
  searchControl = new UntypedFormControl('');

  pacientes: IPatient[] = [];

  listOrder = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];

  dadosPaginacao = {
    ordenacao: ORDENACAO_PADRAO,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  constructor(private readonly patientService: PatientService) {}

  ngOnInit(): void {
    this.carregarPacientes();

    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarPacientes();
    });
  }

  filtrarPacientes(): void {
    this.dadosPaginacao.paginaSelecionada = 0;
    this.carregarPacientes();
  }

  limparFiltros(): void {
    this.searchControl.reset('');
    this.dadosPaginacao.paginaSelecionada = 0;
    this.dadosPaginacao.ordenacao = ORDENACAO_PADRAO;
    this.ordenarControl.setValue(ORDENACAO_PADRAO, { emitEvent: false });
    this.carregarPacientes();
  }

  carregarPacientes(): void {
    const filtros: IListByFilterPatient = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    if (this.searchControl.value) {
      filtros.searchText = String(this.searchControl.value);
    }

    this.patientService.listarPacientes(filtros).subscribe((resposta) => {
      this.pacientes = resposta.data;
      const count = resposta.count ?? resposta.data.length;
      this.dadosPaginacao.totalPaginas = Math.ceil(count / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = count;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;
    this.carregarPacientes();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacao.paginaSelecionada = 0;
    this.carregarPacientes();
  }

  public exportarPacientesCsv(): void {
    const filtros: IListByFilterPatient = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    if (this.searchControl.value) {
      filtros.searchText = String(this.searchControl.value);
    }

    this.patientService.exportarCsv(filtros);
  }
}
